import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import { compose } from 'recompose'

import { notification, setPage, modal, logError } from 'redux/modules/app'
import {
  participants as participantsApi,
  persons as personsApi,
  tasks as tasksApi,
  awards as awardsApi
} from 'redux/modules/api'
import { updateScheme, createScheme } from 'models/participants'
import { getLeaderId } from 'utils/token'
import { mapParticipantsForBulk, mapParticipantsGridForBulk,
  areAllSelectedForBulk, areAllSelectedInGridForBulk } from 'redux/selectors/participants'
import { getFormValues } from 'redux-form'
import appConfig from 'config'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'



function decorator(config = { keepDataOnUnmount: true }) {
  return ComposedComponent => {
    const enhance = compose(
      connect(
        state => ({
          localeId: state.app.locale.id,
          user: state.auth.user,
          activeOrganization: state.auth.organization,
          participants: state.api.participants,
          local: {
            registrationTasks: state.api.tasks.registrationParticipants,
            unassignedParticipantsTasks: state.api.tasks.unassignedParticipants
          },
          selectableParticipantIds: config.list
            ? (config.listGrid
              ? mapParticipantsGridForBulk(state)
              : mapParticipantsForBulk(state)
            )
            : [],
          areAllParticipantsSelected: config.list
            ? (config.listGrid
                ? areAllSelectedInGridForBulk(state)
                : areAllSelectedForBulk(state)
            )
            : false,
          commonLimit: state.app.commonLimit,
          mergeParticipantValues: getFormValues(config.form)(state),
          deleteParticipantAwardValues: getFormValues(config.form)(state),
          formChangeAwardModeValues: getFormValues(config.form)(state),
          recoverParticipantValues: getFormValues(config.form)(state),
          configuration: state.api.configuration
        }),
        {
          ...participantsApi,
          notification,
          modal,
          logError,
          setPage,
          push,
          uploadPersonImage: personsApi.uploadPersonImage,
          deletePersonImage: personsApi.deletePersonImage,
          getTasksParticipantRegistration: tasksApi.registrationParticipants
            .getTasksParticipantRegistration,
          getTasksUnassignedParticipants: tasksApi.unassignedParticipants
            .getTasksUnassignedParticipants,
          getTasksOverview: tasksApi.overview.getTasksOverview,
          updateAward: awardsApi.updateAward,
          updateAwardPaymentInfo: awardsApi.updateAwardPaymentInfo,
          bulkSelectParticipants: participantsApi.toggleParticipantsAllSelected
        }
      )
    )

    class Participants extends Component {
      static propTypes = {
        decoUpdateOrganizationOverview: PropTypes.bool,
        local: PropTypes.object,
        user: PropTypes.object,
        activeOrganization: PropTypes.object,
        decoFilter: PropTypes.string,
        allowParticipantsFilter: PropTypes.bool,
        participants: PropTypes.object.isRequired,
        params: PropTypes.object.isRequired,
        commonLimit: PropTypes.number,
        localeId: PropTypes.number.isRequired,
        getParticipants: PropTypes.func.isRequired,
        getParticipantsGrid: PropTypes.func.isRequired,
        getParticipantsGridCount: PropTypes.func.isRequired,
        getAssessorsActivityParticipants: PropTypes.func.isRequired,
        getAssessorsAJParticipants: PropTypes.func.isRequired,
        getAssessorsRPParticipants: PropTypes.func.isRequired,
        getParticipant: PropTypes.func.isRequired,
        updateParticipant: PropTypes.func.isRequired,
        createParticipant: PropTypes.func.isRequired,
        deleteParticipant: PropTypes.func.isRequired,
        deleteParticipantRegistration: PropTypes.func.isRequired,
        sendEmailInvitation: PropTypes.func.isRequired,
        sendConfirmationEmail: PropTypes.func.isRequired,
        passwordResetRequest: PropTypes.func.isRequired,
        updateAward: PropTypes.func.isRequired,
        updateAwardPaymentInfo: PropTypes.func.isRequired,
        getTasksParticipantRegistration: PropTypes.func.isRequired,
        getTasksUnassignedParticipants: PropTypes.func.isRequired,
        getTasksOverview: PropTypes.func.isRequired,
        uploadPersonImage: PropTypes.func.isRequired,
        deletePersonImage: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        removeParticipantsCache: PropTypes.func.isRequired,
        removeParticipantsDetailData: PropTypes.func.isRequired,
        exportParticipants: PropTypes.func.isRequired,
        exportParticipantsGrid: PropTypes.func.isRequired,
        setParticipantsSelected: PropTypes.func.isRequired,
        setParticipantsParams: PropTypes.func,
        setAssessorActivityParticipantsParams: PropTypes.func,
        setAssessorAJParticipantsParams: PropTypes.func,
        setAssessorRPyParticipantsParams: PropTypes.func,
        notification: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        logError: PropTypes.func.isRequired,
        setPage: PropTypes.func.isRequired,
        mergeAccounts: PropTypes.func,
        configuration: PropTypes.object.isRequired
      }

      static defaultProps = {
        allowParticipantsFilter: true,
        params: {}
      }

      componentDidMount() {
        const { params, commonLimit, setParticipantsParams, participants } = this.props


        if (config.useCommonLimit && commonLimit) {
          setParticipantsParams({ limit: commonLimit })
        }

        // commented out participants fetching, as calling it in both didMount and willReceiveProps functions was calling this fetch
        // and it caused race condition problem in some specific scenarios (see [SDNO-1063])
        // calling it only in willReceiveProps should be enough, as connect() should always cause execution of willReceiveProps function
        // config.list &&
        //   this.handleGetParticipants(participants, this.handleGetBaseFilter()).then(() => console.log('getParticipants - mount'))
        config.detail && params.id && this.handleGetParticipant(params.id)
        config.assessorActivityParticipants && this.handleGetAssessorParticipants(participants, 'assessorActivityParticipants')
        config.assessorAJParticipants && this.handleGetAssessorParticipants(participants, 'assessorAJParticipants')
        config.assessorRPParticipants && this.handleGetAssessorParticipants(participants, 'assessorRPParticipants')
      }

      componentWillReceiveProps = async(nextProps) => {
        const { participants } = this.props


        if (config.list && !config.listGrid) {
          const { filter, limit, offset, sort, invalidate } = nextProps.participants

          if (participants.filter !== filter ||
            participants.limit !== limit ||
            participants.offset !== offset ||
            participants.sort !== sort ||
            participants.invalidate !== invalidate) {

            await this.loadLabelConfig()
            this.handleGetParticipants(
              nextProps.participants,
              this.handleGetBaseFilter()
            )
          }
        }

        if (config.list && config.listGrid) {
          const { filter, limit, offset, sort, invalidate } = nextProps.participants.grid

          if (participants.grid.filter !== filter ||
            participants.grid.limit !== limit ||
            participants.grid.offset !== offset ||
            participants.grid.sort !== sort ||
            participants.grid.invalidate !== invalidate) {

            const reloadCount=
              participants.grid.filter !== filter || participants.grid.invalidate !== invalidate

            await this.loadLabelConfig()
            this.handleGetParticipantsGrid(
              nextProps.participants.grid,
              this.handleGetGridBaseFilter(),
              reloadCount
            )
          }
        }

        if (
            get(participants, 'assessor.activity.filter') !== get(nextProps, 'participants.assessor.activity.filter') ||
            get(participants, 'assessor.activity.limit') !== get(nextProps, 'participants.assessor.activity.limit') ||
            get(participants, 'assessor.activity.offset') !== get(nextProps, 'participants.assessor.activity.offset') ||
            get(participants, 'assessor.activity.sort') !== get(nextProps, 'participants.assessor.activity.sort') ||
            get(participants, 'assessor.activity.invalidate') !== get(nextProps, 'participants.assessor.activity.invalidate')
        ) {
          config.assessorParticipantsList && this.handleGetAssessorParticipants(nextProps.participants,'assessorParticipantsActivity')
        }

        if (
            get(participants, 'assessor.aj.filter') !== get(nextProps, 'participants.assessor.aj.filter') ||
            get(participants, 'assessor.aj.limit') !== get(nextProps, 'participants.assessor.aj.limit') ||
            get(participants, 'assessor.aj.offset') !== get(nextProps, 'participants.assessor.aj.offset') ||
            get(participants, 'assessor.aj.sort') !== get(nextProps, 'participants.assessor.aj.sort') ||
            get(participants, 'assessor.aj.invalidate') !== get(nextProps, 'participants.assessor.aj.invalidate')
        ) {
          config.assessorParticipantsList && this.handleGetAssessorParticipants(nextProps.participants,'assessorAJParticipants')
        }

        if (
            get(participants, 'assessor.rp.filter') !== get(nextProps, 'participants.assessor.rp.filter') ||
            get(participants, 'assessor.rp.limit') !== get(nextProps, 'participants.assessor.rp.limit') ||
            get(participants, 'assessor.rp.offset') !== get(nextProps, 'participants.assessor.rp.offset') ||
            get(participants, 'assessor.rp.sort') !== get(nextProps, 'participants.assessor.rp.sort') ||
            get(participants, 'assessor.rp.invalidate') !== get(nextProps, 'participants.assessor.rp.invalidate')
        ) {
          config.assessorParticipantsList && this.handleGetAssessorParticipants(nextProps.participants,'assessorRPParticipants')
        }

      }

      componentWillUnmount = () =>
        !config.keepDataOnUnmount && this.props.removeParticipantsDetailData()

      handleGetBaseFilter = () => {
        const { user, params, allowParticipantsFilter, decoFilter } = this.props

        switch (allowParticipantsFilter && (decoFilter || config.filter)) {
          case 'myParticipants':
            return `awards.awardLeader.id=${getLeaderId(user)}`
          case 'awardUnitParticipants':
            return `awards.organization.id=${params && params.id}`
          case 'leaderParticipants':
            return `awards.awardLeader.id=${params && params.id}`
          case 'organizationParticipants':
            return `awards.organization.flatHierarchy.parentOrganization.id=${params && params.id}`
          case 'assessorParticipantsActivity':
            return 'assessorActivityParticipants'
          case 'assessorAJParticipants':
            return 'assessorAJParticipants'
          case 'assessorRPParticipants':
            return 'assessorRPParticipants'
          default:
            return ''
        }
      }

      handleGetGridBaseFilter = () => {
        const { params, allowParticipantsFilter, decoFilter } = this.props

        switch (allowParticipantsFilter && (decoFilter || config.filter)) {
          case 'myParticipants':
            return { name: 'myParticipants', value: null }
          case 'awardUnitParticipants':
            return { name: 'awardUnitParticipants', value: (params && params.id) }
          case 'leaderParticipants':
            return { name: 'leaderParticipants', value: (params && params.id) }
          case 'organizationParticipants':
            return { name: 'organizationParticipants', value: (params && params.id) }
          case 'assessorParticipantsActivity':
            return 'assessorActivityParticipants'
          case 'assessorAJParticipants':
            return 'assessorAJParticipants'
          case 'assessorRPParticipants':
            return 'assessorRPParticipants'
          default:
            return ''
        }
      }

      loadLabelConfig = async() => {
        const { organizationId, onGetConfigurationValue } = this.props
        await Promise.all([
            onGetConfigurationValue(CONFIGURATION_KEYS.enableLabels.id, organizationId),
            onGetConfigurationValue(CONFIGURATION_KEYS.enableAwardLabels.id, organizationId)
          ])
      }

      handleGetParticipants = (participants, baseFilter) => {
        const { configuration,organizationId, activeOrganization } = this.props

        const orgId =  organizationId || activeOrganization.id

        const isParticipantLabelsEnabled = get(configuration, `valuesByOrganizationId.${orgId}.${CONFIGURATION_KEYS.enableLabels.id}.booleanValue`)

        const isAwardLabelsEnabled = get(configuration, `valuesByOrganizationId.${orgId}.${CONFIGURATION_KEYS.enableAwardLabels.id}.booleanValue`)

        let listReadParams = ''

        if (isParticipantLabelsEnabled){
          listReadParams = 'LABELS'
        }

        if (isAwardLabelsEnabled){
          listReadParams += listReadParams.length > 0 ? ',AWARD_LABELS' : 'LABELS,AWARD_LABELS'
        }

        return this.props
            .getParticipants(participants, baseFilter, listReadParams)
            .catch(this.handleError)
      }

      handleGetParticipantsGrid = (participants, baseFilter, reloadCount) => {
        this.props
          .getParticipantsGrid(participants, baseFilter)
          .catch(this.handleError)

        reloadCount && this.props
            .getParticipantsGridCount(participants, baseFilter)
            .catch(this.handleError)
      }

      handleGetAssessorParticipants = (participants, baseFilter) => {
        const { params } = this.props

        if(baseFilter === 'assessorParticipantsActivity'){
          return this.props
              .getAssessorsActivityParticipants(participants, baseFilter, {
                assessorId: params.assessorId,
                organizationId: params.organizationId
              })
              .catch(this.handleError)
        } else if (baseFilter === 'assessorAJParticipants'){
          return this.props
              .getAssessorsAJParticipants(participants, baseFilter, {
                assessorId: params.assessorId,
                organizationId: params.organizationId
              })
              .catch(this.handleError)
        } else if (baseFilter === 'assessorRPParticipants'){
          return this.props
              .getAssessorsRPParticipants(participants, baseFilter, {
                assessorId: params.assessorId,
                organizationId: params.organizationId
              })
              .catch(this.handleError)
        }
      }

      handleGetParticipant = id => {
        this.props.getParticipant(id, config.params).then(({ body }) => {
          const partId = get(body, 'globalId') ? `(${body.globalId})` : ''

          this.props.setPage(
            `${get(body, 'firstName')} ${get(body, 'lastName')} ${partId}`,
            true
          )
        })
      }

      handleParticipantUpdateBlob = fields => {
        if (fields.file) {
          return this.props
            .uploadPersonImage(fields.id, fields.file)
            .then(() => {
              this.handleParticipantUpdate(fields)
            })
            .catch(this.handleError)
        }

        if (
          get(this.props.participants, 'detail.photoUrl') && !fields.photoUrl
        ) {
          return this.props.deletePersonImage(fields.id).then(() => {
            this.handleParticipantUpdate(fields)
          })
        }

        return this.handleParticipantUpdate(fields)
      }

      handleParticipantUpdate = (fields, update) => {
        const { localeId } = this.props
        const params = {
          localeId
        }

        return this.props
          .updateParticipant(updateScheme(fields, params), update)
          .then(() => {
            this.handleUpdateSuccess()
          })
          .catch(this.handleError)
      }

      handleParticipantStateChange = (participantId, fields) => {
        this.handleParticipantUpdate(
          { id: participantId, ...fields },
          'CHANGE_PERSON_STATE'
        )
      }

      handleParticipantCreateBlob = fields => {
        if (fields.file) {
          this.props.uploadPersonImage(fields.file).then(res => {
            this.handleParticipantCreate(fields, res.body.photoUrl)
          })
        } else {
          this.handleParticipantCreate(fields)
        }
      }

      handleExportParticipants = () => {
        const { participants } = this.props

        return this.props
          .exportParticipants(participants, this.handleGetBaseFilter())
          .catch(this.handleError)
      }

      handleExportParticipantsGrid = () => {
        const { participants } = this.props

        return this.props
          .exportParticipantsGrid(participants.grid, this.handleGetGridBaseFilter())
          .catch(this.handleError)
      }

      handleParticipantCreate = (fields, photoUrl) => {
        const { localeId, activeOrganization } = this.props
        const params = {
          localeId,
          organizationId: activeOrganization.id,
          photoUrl
        }

        this.props
          .createParticipant(createScheme(fields, params))
          .then(this.handleCreateSuccess)
          .catch(this.handleError)
      }

      handleParticipantDelete = (participantId, fields = {}) =>
        this.props
          .deleteParticipant(participantId, {
            reason: fields.reason
          })
          .then(this.handleDeleteSuccess)
          .catch(this.handleError)

      handledeleteParticipantRegistration = (
        id,
        fields,
        { participantRegistrationId } = {}
      ) =>
        this.props
          .deleteParticipantRegistration(id, fields, {
            participantRegistrationId
          })
          .then(this.handleDeleteParticipantRegistrationSuccess)
          .catch(this.handleError)

      handleUpdateParticipantOptions = fields => {
        // refactor
        return this.props
          .updateParticipant(updateScheme(fields, {}))
          .then(this.handleUpdateSuccess)
          .catch(this.handleError)
      }

      handleSendEmailInvitation = (email, participantName) =>
        this.props
          .sendEmailInvitation(email, participantName)
          .then(this.handleEmailSentSuccess)
          .catch(this.handleError)

      handleSendConfirmationEmail = participantId =>
        this.props
          .sendConfirmationEmail(participantId)
          .then(this.handleConfirmationEmailSuccess)
          .catch(this.handleError)

      handleMergeAccount = (sourceParticipantId, targetParticipantId) =>
        this.props.mergeAccounts(sourceParticipantId, targetParticipantId)
          .then(this.handleMergeAccountsSuccess)
          .catch(this.handleError)

      handleRecoverParticipant = deletedParticipantId =>
          this.props.recoverParticipant(deletedParticipantId)
              .then(this.handleRecoverParticipantSuccess)
              .catch(this.handleError)

      handlePasswordResetRequest = email =>
        this.props
          .passwordResetRequest(email)
          .then(this.handlePasswordResetRequestSuccess)
          .catch(this.handleError)

      handleUpdateSuccess = () => {
        const { params } = this.props

        config.detail &&
        params &&
        params.id &&
        this.handleGetParticipant(params.id)
        this.props.notification('Participant has been updated', {
          status: 'success',
          intlKey: 'notifications.participant_has_been_updated'
        })
        this.handleRefresh()
      }

      handleDeleteParticipantRegistrationSuccess = () => {
        this.props.notification('Participant registration has been removed', {
          status: 'success',
          intlKey: 'notifications.participant_registration_has_been_removed'
        })
        this.handleRefresh({ isDeleted: true })
      }

      handleCreateSuccess = res => {
        this.props.removeParticipantsCache()
        this.props.notification('Participant has been created', {
          status: 'success',
          intlKey: 'notifications.participant_has_been_created'
        })
        this.props.push(`${appConfig.publicPath}/participants/${res.body.id}/detail`)
      }

      handleDeleteSuccess = () => {
        this.props.notification('Participant has been deleted', {
          status: 'success',
          intlKey: 'notifications.participant_has_been_deleted'
        })
        this.handleRefresh({ isDeleted: true })
      }

      handleEmailSentSuccess = () => {
        this.props.notification('Invitation has been sent', {
          status: 'success',
          intlKey: 'notifications.invitation_has_been_sent'
        })
        this.handleRefresh()
        this.props.modal(null)
      }

      handlePasswordResetRequestSuccess = () => {
        this.props.notification('Password change request has been sent', {
          status: 'success',
          intlKey: 'notifications.password_change_request_has_been_sent'
        })
        this.handleRefresh()
        this.props.modal(null)
      }

      handleConfirmationEmailSuccess = () => {
        this.props.notification('Confirmation email has been sent', {
          status: 'success',
          intlKey: 'notifications.confirmation_email_has_been_sent'
        })
        this.handleRefresh()
        this.props.modal(null)
      }

      handleMergeAccountsSuccess = () => {
        this.props.notification('Accounts were merged.', {
          status: 'success',
          intlKey: 'notifications.accounts_were_merged'
        })
        this.props.modal(null)
      }

      handleRecoverParticipantSuccess = () => {
        this.props.notification('Deleted participant was recovered.', {
          status: 'success',
          intlKey: 'notifications.deleted_participant_recovered'
        })
        this.props.modal(null)
      }

      handleRefresh = ({ isDeleted } = {}) => {
        const { params, decoUpdateOrganizationOverview } = this.props

        let id = null

        if (decoUpdateOrganizationOverview) {
          id = params.id
        }

        if (config.updateTasks) {
          this.props.getTasksParticipantRegistration(
            this.props.local.registrationTasks
          )
          this.props.getTasksUnassignedParticipants(
            this.props.local.unassignedParticipantsTasks
          )
          this.props.getTasksOverview(null, {
            orgId: id,
            activeOrganizationId: this.props.activeOrganization.id,
            awardLeaderId: this.props.user.personId
          })
        }
        this.props.modal(null)

        if (config.redirectToParticipants && isDeleted) {
          this.props.push(`${appConfig.publicPath}/participants`)
          this.props.removeParticipantsDetailData()
        }
      }

      handleError = err => {
        console.log('error', err.body && err.body.userMessage)
        this.props.logError(err)
      }

      handleUpdateAwardPaymentInfo = (id, data) =>
        this.props.updateAwardPaymentInfo(id, data)

      handleUpdateAward = (id, data, updateDefinition) =>
        this.props.updateAward(id, data, updateDefinition)

      handleSetParticipantSelectedTo = (id, newVal) => {
        const ids = this.props.participants.selectedIds || []
        const newIds = ids.filter(i => i !== id).concat(newVal ? [id] : [])

        this.props.setParticipantsSelected(newIds)
      }

      render () {
        return (
          <ComposedComponent
            {...this.props}
            updateParticipant={this.handleParticipantUpdateBlob}
            exportParticipants={this.handleExportParticipants}
            exportParticipantsGrid={this.handleExportParticipantsGrid}
            createParticipant={this.handleParticipantCreateBlob}
            deleteParticipant={this.handleParticipantDelete}
            deleteParticipantRegistration={
              this.handledeleteParticipantRegistration
            }
            updateParticipantOptions={this.handleUpdateParticipantOptions}
            sendEmailInvitation={this.handleSendEmailInvitation}
            sendRecoveryPassword={this.handlePasswordResetRequest}
            sendConfirmationEmail={this.handleSendConfirmationEmail}
            onParticipantStateChange={this.handleParticipantStateChange}
            setParticipantSelectedTo={this.handleSetParticipantSelectedTo}
            local={undefined}
            mergeAccounts={this.handleMergeAccount}
            recoverParticipant={this.handleRecoverParticipant}
            onGetParticipant={this.handleGetParticipant}
          />
        )
      }
    }

    return enhance(Participants)
  }
}

export default decorator
